document.addEventListener("turbo:load", () => {
  const countrySelect = $("#country_select");
  if (!countrySelect.length) return;

  countrySelect.off("change.countryStateToggle").on("change.countryStateToggle", function () {
    const isUS = $(this).val() === "US";

    const stateSelectWrapper = $("#state_select_wrapper");
    const stateTextWrapper = $("#state_text_wrapper");
    const stateSelect = $("#state_select");
    const stateText = $("#state_text");

    const zipInput = $("#address_zip");
    const zipRequired = $(".zip_required");

    if (isUS) {
      stateSelectWrapper.removeClass("d-none");
      stateSelect.prop("disabled", false);

      stateTextWrapper.addClass("d-none");
      stateText.prop("disabled", true).val("");

      zipInput.prop("required", true);
      zipRequired.removeClass("d-none");
    } else {
      stateSelectWrapper.addClass("d-none");
      stateSelect.prop("disabled", true).val("");

      stateTextWrapper.removeClass("d-none");
      stateText.prop("disabled", false);

      zipInput.prop("required", false);
      zipRequired.addClass("d-none");
    }
  });

  countrySelect.trigger("change");
});